/* eslint-disable sonarjs/no-duplicate-string */
import { BreadCrumb } from '@cigna/chcp/shared/util';
import { PageNavbarItem } from './patient.model';

export const healthWellnessCheckCodes = [
  'CS',
  'CI',
  'CH',
  'CR',
  'SR',
  'ST',
  'SM',
  'TB',
  'QT',
  'QU',
  'WL',
  'CW',
  'HW',
];

export const healthWellnessTranslateCodes = [
  'HB',
  'HP',
  'ON',
  'HA',
  'EAP',
  'EH',
];

export const tierValues = {
  CCN: '4',
  CSN: '9',
  TIER5: '5',
};

export const networkTypeCodes = {
  INN: 'INN',
  OON: 'OON',
  indemnity: 'INDEMNITY',
  preferred: 'PREFERRED',
  partner: 'PARTNER',
  disenfranchised: 'DISENFRANCHISED',
  clientPreferred1: 'Client Preferred Level 1 Network',
  clientPreferred2: 'Client Preferred Level 2 Network',
  clientNonPreferred: 'Client Non-preferred Network',
};

export const networkOrder = [
  networkTypeCodes.preferred,
  networkTypeCodes.clientPreferred1,
  networkTypeCodes.clientPreferred2,
  networkTypeCodes.clientNonPreferred,
  networkTypeCodes.indemnity,
  networkTypeCodes.INN,
  networkTypeCodes.OON,
];

export const MAX_PATIENTS_PER_SEARCH = 10;

// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum PAGE_STAGE {
  default = 'default',
  submitting = 'submitting',
  error = 'error',
  success = 'success',
}

// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum COVERAGE_STATUS {
  active = 'A',
  inactive = 'I',
}

export const MEDICAL_TAB: PageNavbarItem = {
  url: 'medbh',
  label: 'Medical',
  translateLabel: false,
};
export const MENTAL_TAB: PageNavbarItem = {
  url: 'mhsr',
  label: 'Mental Health',
  translateLabel: false,
};
export const CIGNA_MEDICAL_TAB: PageNavbarItem = {
  url: 'medbh',
  label: 'Cigna Medical',
  translateLabel: false,
  extras: {
    queryParams: {
      scrollTo: null,
    },
  },
};
export const BEHAVIORAL_TAB: PageNavbarItem = {
  url: 'mhsr',
  label: 'Behavioral',
  translateLabel: false,
  disable: false,
  extras: {
    queryParams: {
      scrollTo: null,
    },
  },
};
export const DENTAL_TAB: PageNavbarItem = {
  url: 'den',
  label: 'Dental',
  translateLabel: false,
};
export const PRECERTIFICATION_TAB: PageNavbarItem = {
  url: 'precertification',
  label: 'Precertifications',
  translateLabel: false,
  disable: false,
  extras: {
    queryParams: {
      scrollTo: null,
    },
  },
};

export interface UsefulLink {
  path: string;
  name: string;
  resourceLink: boolean;
}

export interface HelpContact {
  name: string;
  contactNumber: string;
}

export const DENTAL_USEFUL_LINKS: UsefulLink[] = [
  {
    path: '/resourceLibrary/forms/formsDentalListing',
    name: 'Forms',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/paymentGuidelines/paymentGuidelinesListing',
    name: 'Payment Guidelines',
    resourceLink: true,
  },
  {
    path: 'http://hcpdirectory.cigna.com',
    name: 'Provider Directory',
    resourceLink: false,
  },
];

export const MEDICAL_USEFUL_LINKS_1: UsefulLink[] = [
  {
    path: '/resourceLibrary/coveragePolicies/index',
    name: 'View Coverage Positions',
    resourceLink: true,
  },
];

export const MEDICAL_USEFUL_LINKS_2: UsefulLink[] = [
  {
    path: '/resourceLibrary/formsCenter',
    name: 'Forms',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/clinicalReimbursementPayment/clinReimAndPayPolsListing',
    name: 'Policies and Procedures',
    resourceLink: true,
  },
  {
    path: 'http://hcpdirectory.cigna.com',
    name: 'Provider Directory',
    resourceLink: false,
  },
];

export const MEDICAL_BEHAVIORAL_LINK: UsefulLink[] = [
  {
    path: 'https://well.evernorth.com/public/directory',
    name: 'Behavioral Directory',
    resourceLink: false,
  },
];
export const EVP_MEDICAL_BEHAVIORAL_LINK: UsefulLink[] = [
  {
    path: 'https://well.evernorth.com/public/directory',
    name: 'Behavioral Directory',
    resourceLink: false,
  },
];

export const MEDICAL_SUREFIT_LINK: UsefulLink[] = [
  {
    path: '',
    name: "Patient's SureFit Directory",
    resourceLink: false,
  },
];

export const EVP_MHSR_USEFUL_LINKS: UsefulLink[] = [
  {
    path: '/resourceLibrary/behavioralResources/cbhMedicalMgmtListing',
    name: 'Behavioral Administrative Guidelines',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/behavioralResources/medicalNecessityListing',
    name: 'Medical Necessity Criteria',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/coveragePolicies/index',
    name: 'View Coverage Positions',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/clinicalReimbursementPayment/clinReimAndPayPolsListing',
    name: 'Policies and Procedures',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/forms/formsCBHListing',
    name: 'Forms',
    resourceLink: true,
  },
];

export const MHSR_USEFUL_LINKS: UsefulLink[] = [
  {
    path: '/resourceLibrary/behavioralResources/cbhMedicalMgmtListing',
    name: 'Medical Management Program',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/behavioralResources/medicalNecessityListing',
    name: 'Medical Necessity Criteria',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/coveragePolicies/index',
    name: 'Coverage Policies',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/forms/formsCBHListing',
    name: 'Forms',
    resourceLink: true,
  },
];

export const HELP_CONTACT = [
  {
    name: 'General Assistance:',
    contactNumber: '1.800.88.CIGNA <br/> (1.800.882.4462)',
  },
  {
    name: 'Technical Web Site Assistance:',
    contactNumber: '1.800.261.6232',
  },
  {
    name: 'Site Navigation and <br/> Registration Assistance:',
    contactNumber: '1.800.853.2713',
  },
];

export const MEDICARE_HELP_CONTACT = [
  {
    name: 'General Assistance and Provider Services:',
    contactNumber:
      '800.627.7534 – Arizona <br/> 800.230.6138 – All other states',
  },
  {
    name: 'Site Navigation and Registration:',
    contactNumber: '1.800.853.2713',
  },
];

export const MEDICARE_USEFUL_LINKS = [
  {
    path: '/resourceLibrary/coveragePolicies/index',
    name: 'View Coverage Positions',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/formsCenter',
    name: 'Forms',
    resourceLink: true,
  },
  {
    path: '/resourceLibrary/clinicalReimbursementPayment/clinReimAndPayPolsListing',
    name: 'Policies and Procedures',
    resourceLink: true,
  },
  {
    path: 'https://providersearch.hsconnectonline.com/Directory/',
    name: 'Provider Directory',
    resourceLink: false,
  },
];

export const dtFormat = 'MM/dd/yyyy';
export const ID_SSN_DISPLAY_TEXT = 'Used Subscriber SSN';

export const CRUMB_SEARCH: BreadCrumb = {
  name: 'Patient Search',
  url: '/patient/search',
};

export const CRUMB_RESULT: BreadCrumb = {
  name: 'Results',
  url: '/patient/results',
};

export const STATIC_BENEFIT_TAGS = [
  'PRESCRIPTION COVERAGE',
  'MATERNITY',
  'INFERTILITY SERVICES',
  'VISION SERVICES',
];

export const productTypeDefs = {
  PCLM: 'PPO/OAP',
  PMHS: 'Managed Care',
  GWFC: 'GWH-Cigna/IFP',
  WDEN: 'DHMO',
  DNTC: 'DPPO',
  CGHB: 'Cigna Global',
  QCRE: 'Medicare Advantage',
  QNXT: 'Medicare Advantage',
  GBSF: 'Medicare Advantage',
  CBH: 'Behavioral Standalone',
};
